"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPermission = void 0;
exports.checkPermission = function (available, necessary, accessType) {
    if (!available)
        return false;
    var permission = available[necessary];
    return !!(permission && permission[accessType]);
};
//# sourceMappingURL=permission.js.map